"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewPlatform = void 0;
var ReviewPlatform;
(function (ReviewPlatform) {
    ReviewPlatform["JUDGEME"] = "JUDGEME";
    ReviewPlatform["OKENDO"] = "OKENDO";
    ReviewPlatform["YOTPO"] = "YOTPO";
    ReviewPlatform["STAMPED"] = "STAMPED";
    ReviewPlatform["LOOX"] = "LOOX";
})(ReviewPlatform || (exports.ReviewPlatform = ReviewPlatform = {}));
